module.exports = __webpack_public_path__ + "img/user_init_logo.cbc138b7.png";